import {
  createSlice,
  createSelector,
  PayloadAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import { infoSnack, successSnack, errorSnack } from "../snackbar/snackbarSlice";
// thunkAPI.dispatch(successSnack('Fetched Users'));
// thunkAPI.dispatch(infoSnack('Look at these Users'));
// thunkAPI.dispatch(errorSnack('User error'));
import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const fetchCouriers = createAsyncThunk(
  "couriers/fetchCouriers",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/courier_companies${args.query}`,
        config
      );
      thunkAPI.dispatch(setCouriersAmount(response.headers["x-total-count"]));
      thunkAPI.dispatch(setLastQuery(args.query));

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
        thunkAPI.dispatch(infoSnack("Session expired, please log in again"));
      } else if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching couriers list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreCouriers = createAsyncThunk(
  "couriers/fetchMoreCouriers",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/courier_companies${args.query}&offset=${args.offset}`,
        config
      );
      // let catQuery = [];
      // if (args.query.includes("categories")) {
      //   let urlSearchParams = new URLSearchParams(args.query);
      //   let params = Object.fromEntries(urlSearchParams.entries());
      //   catQuery = params.categories;
      // }
      // thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setCouriersAmount(response.headers["x-total-count"]));
      // thunkAPI.dispatch(updateCategories(catQuery));
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const filterCouriers = createAsyncThunk(
  "couriers/filterCouriers",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/courier_companies${args.query}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchCourierByID = createAsyncThunk(
  "couriers/fetchCourierByID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/courier_companies/${args.id}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
        thunkAPI.dispatch(infoSnack("Session expired, please log in again"));
      } else if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching couriers data"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const deleteCourier = createAsyncThunk(
  "couriers/deleteCourier",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.delete(
        `${baseURL}/v1/admin/courier_companies/${args.id}`,
        config
      );
      thunkAPI.dispatch(successSnack("Courier deleted successfully"));

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
        thunkAPI.dispatch(infoSnack("Session expired, please log in again"));
      } else if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error deleting courier"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const updateCourier = createAsyncThunk(
  "couriers/updateCourier",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.patch(
        `${baseURL}/v1/admin/courier_companies/${args.id}`,
        args.courier,
        config
      );
      thunkAPI.dispatch(fetchCouriers({ token: args.token, query: "" }));
      thunkAPI.dispatch(successSnack("Courier updated successfully"));

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
        thunkAPI.dispatch(infoSnack("Session expired, please log in again"));
      } else if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error updating courier"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const createCourier = createAsyncThunk(
  "couriers/createCourier",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.post(
        `${baseURL}/v1/admin/courier_companies`,
        args.courier,
        config
      );
      thunkAPI.dispatch(fetchCouriers({ token: args.token, query: "" }));
      thunkAPI.dispatch(successSnack("Courier created successfully"));

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
        thunkAPI.dispatch(infoSnack("Session expired, please log in again"));
      } else if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error creating courier"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullList = createAsyncThunk(
  "products/getFullList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreCouriers(requestData))
      )
    )
      .then((results) => {})
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full product list");
      });
  }
);

const couriersSlice = createSlice({
  name: "couriers",
  initialState: {
    courier: {},
    couriersList: [],
    couriersFilter: [],
    loading: "idle",
    message: "",
    error: "",
    editing: false,
    couriersAmount: "",
    lastQuery: "",
  },
  reducers: {
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setCouriersAmount: (state, action) => {
      state.couriersAmount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCouriers.pending, (state) => {
      state.couriersList = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchCouriers.fulfilled, (state, { payload }) => {
      state.couriersList = payload;
      state.couriersFilter = payload;
      state.loading = "loaded";
      state.editing = false;
    });
    builder.addCase(fetchCouriers.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchMoreCouriers.fulfilled, (state, { payload }) => {
      state.error = "";
      state.couriersList = state.couriersList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreCouriers.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(getFullList.fulfilled, (state, { payload }) => {
      state.error = "";
      state.couriersList = state.couriersList.sort(function (a, b) {
        return a.id - b.id;
      });
      state.loading = "loaded";
    });
    builder.addCase(getFullList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(filterCouriers.pending, (state) => {
      state.couriersFilter = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(filterCouriers.fulfilled, (state, { payload }) => {
      state.couriersFilter = payload;
      state.loading = "loaded";
    });
    builder.addCase(filterCouriers.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchCourierByID.pending, (state) => {
      state.courier = {};
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchCourierByID.fulfilled, (state, { payload }) => {
      state.courier = payload;
      state.loading = "loaded";
      state.editing = true;
    });
    builder.addCase(fetchCourierByID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(deleteCourier.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(deleteCourier.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(deleteCourier.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(updateCourier.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(updateCourier.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(updateCourier.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(createCourier.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(createCourier.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(createCourier.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
  },
});

export const {
  setLastQuery,
  setCouriersAmount,
} = couriersSlice.actions;

export const selectCouriers = createSelector(
  (state) => ({
    couriers: state.couriers,
    loading: state.couriers.loading,
    error: state.couriers.error,
    editing: state.couriers.editing,
    courier: state.couriers.courier,
    couriersList: state.couriers.couriersList,
    couriersAmount: state.couriers.couriersAmount,
    lastQuery: state.couriers.lastQuery,
  }),
  (state) => state
);
export default couriersSlice.reducer;
